import axios from '../http'

function query(data) {
    return axios.post('/event/sixteenBracket/query', data);
}


function get(id) {
    return axios.get('/event/sixteenBracket/get?id=' + id);
}

export default {
    query,
    get
}